// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container__w4lnB","details":"styles__details__2bsWb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductCustom/styles.scss
// module id = 403
// module chunks = 0